import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useEffect } from "react";

export default function Pdg() {

    useEffect(() => {
        const downloadBtn = document.getElementById("pitch_deck_presentation");
        const downloadpresentation_docBtn = document.getElementById("presentation_doc");
        const downloadstrategic_planBtn = document.getElementById("strategic_plan");

        if (downloadBtn) {
            downloadBtn.addEventListener("click", async (e) => {
                e.preventDefault();

                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/Pitch Deck Presentation.pptx"
                        }),
                    });

                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }

                    const data = await response.json();

                    // Trigger browser download
                    const a = document.createElement("a");
                    a.href = data.download_url;
                    a.download = data.file_name || "downloaded-file";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        }

        if (downloadpresentation_docBtn) {
            downloadpresentation_docBtn.addEventListener("click", async (e) => {
                e.preventDefault();

                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/Presentation.pptx"
                        }),
                    });

                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }

                    const data = await response.json();

                    // Trigger browser download
                    const a = document.createElement("a");
                    a.href = data.download_url;
                    a.download = data.file_name || "downloaded-file";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        }


        if (downloadstrategic_planBtn && !downloadstrategic_planBtn.dataset.listenerAttached) {
            downloadstrategic_planBtn.addEventListener("click", async (e) => {
                e.preventDefault();
        
                try {
                    const response = await fetch("https://crypto-price-prediction.nugenesisou.com/download", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "accept": "application/json",
                        },
                        body: JSON.stringify({
                            bucket_name: "nugenesis-web-docs",
                            file_path: "Pitch_Deck_Documents/document/strategic-plan.pdf"
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Failed to fetch download URL");
                    }
        
                    const data = await response.json();
                    window.open(data.download_url, "_blank");
                } catch (error) {
                    alert("Download failed: " + error.message);
                }
            });
        
            // Mark as attached to prevent duplicate listeners
            downloadstrategic_planBtn.dataset.listenerAttached = "true";
        }
        


    }, []);

    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Pitch Deck Guide</span>
                    </div>
                </section>


                <section class="pad bank-benefits default margin-top-content">

                    <div class="content normal">
                        <div data-lavalamp=""></div>

                        <div class="img-frame">
                            <img src="images/nugenesisou/pr-illustration-10.png" alt="" />
                        </div>

                        <div class="data">
                            <div class="text">
                                <h3 class="title">NUGENESIS PITCH DECK GUIDE</h3>
                                <p class="subtitle">
                                    Promoting the Nugenesis eco-system
                                </p>
                                <br></br>
                                <p class="subtitle">
                                    • Fully interoprable capabilities designed for government CBDC's.<br></br>
                                    • DEX exchange 'LedgerX.Exchange'<br></br>
                                    • 'Navis' Artificial Intelligence System<br></br>
                                    • NFT platforms<br></br>
                                    • Green & Gasless implementations<br></br>
                                    • Meta Realm


                                </p>


                            </div>
                            <div class="btns">
                                <a href="#" target="_blank" data-patt="track-btn" id="pitch_deck_presentation" class="">Download</a>
                            </div>
                        </div>

                    </div>

                </section>

                <section class="pad bank-benefits white">
                    <div class="cards">
                        <div class="wrapper">
                            <div class="item">
                                <div data-lavalamp=""></div>
                                <h3 class="title">Meta Realm</h3>
                                <p class="subtitle">
                                    Implemeting AI in the 'Meta Realm' with a real life virtual reality setting. Developed as the future of Social Media and AI interaction
                                </p>
                                <div class="img-frame"><img src="images/nugenesisou/pr-illustration-14.png" alt="" />
                                </div>
                            </div>
                            <div class="item">
                                <div data-lavalamp=""></div>
                                <h3 class="title">LedgerX.Exchange</h3>
                                <p class="subtitle">
                                    A fully fledged decentralised fiat-crypto exchange; V2R launchpad and smart contract DNC's
                                </p>
                                <div class="img-frame height-unset ledgerx-logo"><img src="images/nugenesisou/ledgerx.png" alt="" /></div>
                            </div>
                        </div>
                    </div>

                </section>

                <section class="pad title" id="trust">
                    <div class="content">
                        <div class="title">In-depth Pitch Deck Presentation</div>
                    </div>
                </section>

                <section class="pad trust">
                    <div data-lavalamp=""></div>
                    <div data-lavalamp=""></div>
                    <div class="content">
                        <p class="text">Uncovering the ins and outs of the Nugenesis Network, What are the Highlights, Risks associated, Coin Estimations and how can Nugenesis be future proof?</p>
                        <div class="btns">
                            <a href="#" target="_blank" id="presentation_doc" class="btn-sm">Download</a>
                        </div>
                    </div>
                </section>





                <section class="media">
                    <div class="pad content no-mobile">
                        <div class="head harf-head">
                            <div class="img-frame"><img src="images/media.svg" alt="" /></div>
                            <div class="title">NUGENESIS STRATEGIC PLAN</div>
                            <p class="subtitle">
                                Industry Historic Analysis todo with Financials, MetaRealm, Blockchain
                                and environmental impact with a comparative overview
                            </p>
                            <div class="btns">
                                <a href="document/strategic-plan.pdf" id="strategic_plan" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>
                        </div>
                        <div class="list">
                            <div class="items" data-overflow="media-list" data-overflow-start="5|460:3"
                                data-overflow-class="hide-item">
                                <div class="item">
                                    <a href="#">

                                        <div class="data">
                                        <div class="title"><i></i>Money</div>
                                            <div class="text">Two questions:</div>
                                            <p class="subtitle">
                                                1. How do we make money out of this NuGenesis
                                                network platform<br></br>
                                                2. How quickly can I have it?
                                            </p>

                                        </div>
                                    </a>
                                </div>
                                <div class="item">
                                    <a href="#">

                                    <div class="data">
                                        <div class="title"><i></i>Meta Realm</div>
                                            <p class="subtitle">
                                                1. The path to the Meta Realm<br></br>
                                                2. The Multi-Metaverses
                                            </p>

                                        </div>
                                    </a>
                                </div>
                                <div class="item">
                                    <a href="#">

                                    <div class="data">
                                        <div class="title"><i></i>Blockchain</div>
                                            <p class="subtitle">
                                            Layer 1 Blockchain Technology and the
comparisions between different blockchain and
the Nugenesis Network
                                            </p>

                                        </div>
                                    </a>
                                </div>
                                <div class="item">
                                    <a href="#">

                                    <div class="data">
                                        <div class="title"><i></i>Societal Impact</div>
                                            <p class="subtitle">
                                            how is our society impacted and how can
                                            Nugenesis be the solution
                                            </p>

                                        </div>
                                    </a>
                                </div>




                            </div>

                        </div>
                    </div>

                </section>

            </main>
            <Footer />
        </>
    )
}